import { useNavigate, useLocation } from 'react-router-dom'
import { Home, Database, FileText, User } from 'lucide-react'
import { cn } from '@/lib/utils'

export const PrimarySidebarMobileNav = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const navItems = [
    {
      icon: Home,
      label: 'Projects',
      path: '/projects',
      matchPaths: ['/projects'],
    },
    {
      icon: Database,
      label: 'Data',
      path: '/scenarios',
      matchPaths: ['/scenarios', '/datasets'],
    },
    {
      icon: FileText,
      label: 'Tables',
      path: '/tables',
      matchPaths: [
        '/vehicles',
        '/jobs',
        '/locations',
        '/routes',
        '/skills',
        '/products',
      ],
    },
    {
      icon: User,
      label: 'Account',
      path: '/account',
      matchPaths: ['/account', '/settings'],
    },
  ]

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      role="navigation"
      aria-label="Primary navigation"
    >
      <div className="flex items-center justify-around h-16 pointer-coarse:h-20">
        {navItems.map(item => {
          const Icon = item.icon
          const isActive = item.matchPaths.some(path =>
            location.pathname.startsWith(path)
          )

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={cn(
                'flex flex-col items-center justify-center flex-1 gap-1 h-full',
                'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-inset',
                'transition-colors duration-200',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon
                className="w-6 h-6"
                aria-hidden="true"
                strokeWidth={isActive ? 2.5 : 2}
              />
              <span className="text-sm font-semibold">{item.label}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
